import Loader from "../DomUtilities/Loader";
import openErrorModal from "../Error/ErrorModal";
import { sendUserInvitation } from "../HTTPRequests/UserRequests";

export default class UserInvitation {
	icon: HTMLElement;
	id: string;
	name: string;
	confirmModal: HTMLDivElement;

	constructor(invitationIcon: HTMLElement, userId: string, userName: string) {
		this.icon = invitationIcon;
		this.id = userId;
		this.name = userName;

		this.init();
	}

	private init() {
		this.confirmModal = document.querySelector("#invite-user-modal");
		this.confirmModal = this.confirmModal.cloneNode(true) as HTMLDivElement;
		const modalText: HTMLDivElement = this.confirmModal.querySelector(".modal__body div.text-center");
		const question = modalText.innerText.trim();
		modalText.innerText = `${question} ${this.name} ?`;

		this.addIconClickListener();
	}

	private addIconClickListener() {
		this.icon.onclick = (event) => {
			this.openConfirmModal();
			event.stopPropagation();
		}
	}

	private openConfirmModal() {
		this.confirmModal.style.display = "flex";
		document.body.appendChild(this.confirmModal);
		this.addConfirmModalClickListeners();
	}

	private addConfirmModalClickListeners() {
		const closeImg: HTMLImageElement = this.confirmModal.querySelector('img[alt="close icon"]');
		const noButton: HTMLButtonElement = this.confirmModal.querySelector("button");
		const yesButton: HTMLButtonElement = this.confirmModal.querySelector("button + button");

		closeImg.onclick = () => {
			this.confirmModal.remove();
		}

		noButton.onclick = () => {
			this.confirmModal.remove();
		}

		this.confirmModal.onclick = (event) => {
			if (event.target == this.confirmModal) {
				this.confirmModal.remove();
			}
		}

		yesButton.onclick = () => {
			this.sendInvitaion();
		}
	}

	private sendInvitaion() {
		Loader.show();
		this.confirmModal.remove();
		sendUserInvitation(this.id)
			.then(() => {
				this.openSuccessMsgModal();
			}, () => { //backend error
				openErrorModal();
			}).catch(() => { //frontend error
				openErrorModal();
			}).finally(() => {
				Loader.hide();
			});

	}

	private openSuccessMsgModal() {
		let message: string = this.confirmModal.dataset.msg;
		openErrorModal(message, "#AAC291", "  ", "30%", "165px");
	}
}
